<template>
  <div class="travel-list">
    <div class="travel-list-header">
      <el-row>
        <el-col :span="4">
          <i class="el-icon-arrow-left" @click="handleBack()"></i>
        </el-col>
        <el-col :span="16">行程列表</el-col>
        <el-col :span="4">&nbsp;</el-col>
      </el-row>
    </div>
    <div class="travel-list-content">
      <scroller :on-refresh="refresh" :on-infinite="infinite" ref="myscroller">
        <ul>
          <li v-for="(item,index) in travelList" :key="index">
            <div class="travel-list-content-li-left" @click="handleSelect(item)">
              <img :src="item.imgUrl">
            </div>
            <div class="travel-list-content-li-right">
              <h5 @click="handleSelect(item)">{{item.grName}}</h5>
              <span>出发地：{{item.startDestIdSn}}</span>
              <span>目的地：{{Dest(item.area)}}</span>
              <span class="travel-edit" @click="handleEdit(item.grId)">编辑行程</span>
            </div>
          </li>
        </ul>
      </scroller>
      <div class="travel-list-content-add" @click="handleAdd()">
        <!-- <i class="el-icon-plus"></i> -->
        <span>定制行程</span>
      </div>
    </div>
    <div class="travel-list-footer"></div>
  </div>
</template>

<script>
require("../../styles/travel/travel-list.scss");
import { queryTravelList } from "../../actions/portal/protal";
import Vue from "vue";
import VueScroller from "vue-scroller";
import { debuglog } from "util";
Vue.use(VueScroller);

export default {
  data() {
    return {
      travelList: [],
      page: 1,
      pageSize: 10,
      noData: false,
      userId: ""
    };
  },
  components: {},
  mounted() {
    this.getData();
  },
  methods: {
    handleSelect(item) {
      this.$router.push({ path: "/travel-detail", query: { grId: item.grId } });
    },
    getData() {
      this.userId = (this.$localAuth.getUser() || {}).userId;
      let $this = this;
      queryTravelList({
        pageIndex: $this.page,
        pageSize: $this.pageSize,
        userId: this.userId
      }).then(res => {
        if (!res) {
          $this.noData = true;
          this.$refs.myscroller.finishInfinite(true); //不让它加载，，显示“没有更多数据”，不然会一直转圈
          return;
        }
        if ($this.page === res.paging.totalPage) {
          $this.noData = true;
        }
        if ($this.page === 1) {
          $this.travelList = res.data;
        } else {
          $this.travelList = $this.travelList.concat(res.data);
        }
      });
    },
    //下拉刷新
    refresh() {
      this.page = 1; //重置页数
      this.noData = false;
      setTimeout(
        function() {
          this.getData();
          this.$refs.myscroller.finishPullToRefresh(); //刷新完毕关闭刷新的转圈圈
        }.bind(this),
        1700
      );
    },
    //上拉加载
    infinite(done) {
      if (this.noData) {
        this.$refs.myscroller.finishInfinite(true); //不让它加载，，显示“没有更多数据”，不然会一直转圈
      } else {
        setTimeout(() => {
          this.page++; //下拉一次页数+1
          this.getData();
          done(); //进行下一次加载操作
        }, 1500);
      }
    },
   handleBack() {
      window.history.back(-1);
    },
     handleAdd() {
      this.$router.push({ path: "/travel", query: { userId: this.userId } });
    },
    handleEdit(m) {
      this.$router.push({
        path: "/travel/travel-main",
        query: { routeId: m, userId: this.userId }
      });
    },
    Dest(m) {
      var areaCode = "";
      var areaName = "";
      m.filter((o, index, array) => {
        if (o.areaCode != areaCode) {
          areaCode = o.areaCode;
          areaName += o.areaName + ",";
        }
      });
      return areaName.substring(0, areaName.length - 1);
    }
  }
};
</script>

<style scoped>
</style>